import { useCallback } from 'react';

// Magnetic-button behaviour. Spread the returned handlers onto any element you want
// to gently follow the cursor on hover (fine pointers only — touch is left alone).
//
//   const magnetic = useMagnetic();
//   <button {...magnetic}>…</button>
export function useMagnetic(strengthX = 0.22, strengthY = 0.3) {
  const isFine =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(pointer:fine)').matches;

  const onMouseMove = useCallback(
    (e) => {
      if (!isFine) return;
      const el = e.currentTarget;
      const r = el.getBoundingClientRect();
      const mx = e.clientX - (r.left + r.width / 2);
      const my = e.clientY - (r.top + r.height / 2);
      el.style.transform = `translate(${mx * strengthX}px,${my * strengthY}px)`;
    },
    [isFine, strengthX, strengthY]
  );

  const onMouseLeave = useCallback((e) => {
    e.currentTarget.style.transform = 'translate(0,0)';
  }, []);

  if (!isFine) return {};
  return { onMouseMove, onMouseLeave };
}
